const ACCOUNTS = {
    INTERVENERS_TOOLTIP_LIMIT: 9
}

module.exports = ACCOUNTS;
